import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import { BasketIcon, InfoIcon, TimerIcon } from 'assets/svgComponent'
import { Button, Col, Modal, Progress, Row } from 'antd'
import IconDiv from 'component/IconDiv'
import { useNavigate } from 'react-router-dom'
import { useRedux } from 'redux/useRedux'
import { onChangePublic } from 'redux/actions/public'
function CompleteModal(props) {
    const navigate = useNavigate()
    const { publicState, dispatch, authState } = useRedux()
    return (
        <Modal
            open={publicState.completeInfoModal}
            className='modal-one'
            footer={[
                <Row gutter={30} className='mt10'>
                    <Col xs={24}>
                        <Button onClick={() => {
                            dispatch(onChangePublic("completeInfoModal", false));
                            setTimeout(() => {
                                navigate({ pathname: "/account",search: `?back=true`})
                            }, 300);
                        }} className='fullWidth fillButton' >
                            تکمیل اطلاعات
                        </Button>
                    </Col>

                </Row>
            ]}
        >
            <Row align={"middle"}>
                <IconDiv type='success'>
                    <InfoIcon />
                </IconDiv>
                <span className='white100 t3 ms10'>
                    تکمیل اطلاعات
                </span>
            </Row>
            <Col className='fullWidth mt30'  >
                <Row justify={"space-between"}>
                    <span className='t5 white50 mb60' >کاربر گرامی جهت ادامه روند  لطفا اطلاعات  حساب کاربری خود را تکمیل کنید   </span>

                </Row>


            </Col>
        </Modal>
    )
}
CompleteModal.propTypes = {

}

export default CompleteModal

